export default "__VITE_ASSET__Bncq3iH___"